import { Box, Tab, Tabs } from '@mui/material';
import { editor } from 'monaco-editor';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ControllerConfigurationTab from './ControllerConfigurationTab';
import DrivebaseConfigurationTab from './DrivebaseConfigurationTab';
import PathMarkersControlList from './PathMarkersControlList';
import SensorConfigurationTab from './SensorConfigurationTab';

type ControlSubTab = 'controller' | 'drivebase-panel' | 'sensors' | 'path-markers';

interface ControlPanelTabProps {
  editor?: editor.IStandaloneCodeEditor;
}

const ControlPanelTab: React.FC<ControlPanelTabProps> = ({ editor }) => {
  const { t } = useTranslation();
  const [subTab, setSubTab] = useState<ControlSubTab>('controller');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <Tabs
        value={subTab}
        onChange={(_, value: ControlSubTab) => setSubTab(value)}
        sx={(theme) => ({
          borderBottom: 1,
          borderColor: 'divider',
          minHeight: 40,
          '& .MuiTabs-flexContainer': { gap: 0, justifyContent: 'center' },
          '& .MuiTab-root': { minHeight: 40, textTransform: 'none', fontSize: '0.875rem' },
          '& .MuiTabs-indicator': { backgroundColor: theme.vars?.palette?.accent?.main },
        })}
      >
        <Tab
          value="controller"
          label={t('editorDrawer.tabs.controller', 'Controller')}
          aria-label={t('editorDrawer.tabs.controller', 'Controller')}
        />
        <Tab
          value="drivebase-panel"
          label={t('editorDrawer.tabs.drivebasePanel', 'Drivebase')}
          aria-label={t('editorDrawer.tabs.drivebasePanel', 'Drivebase')}
        />
        <Tab value="sensors" label={t('editorDrawer.tabs.sensors', 'Sensors')} aria-label={t('editorDrawer.tabs.sensors', 'Sensors')} />
        <Tab
          value="path-markers"
          label={t('editorDrawer.tabs.pathMarkers', 'Path Markers')}
          aria-label={t('editorDrawer.tabs.pathMarkers', 'Path Markers')}
        />
      </Tabs>
      <Box sx={{ flexGrow: 1, overflowY: 'auto', minHeight: 0 }}>
        {subTab === 'controller' && <ControllerConfigurationTab editor={editor} />}
        {subTab === 'drivebase-panel' && <DrivebaseConfigurationTab editor={editor} />}
        {subTab === 'sensors' && <SensorConfigurationTab editor={editor} />}
        {subTab === 'path-markers' && <PathMarkersControlList editor={editor} />}
      </Box>
    </Box>
  );
};

export default ControlPanelTab;
